import React from 'react'
import PropTypes from 'prop-types'
import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import BloodtypeOutlinedIcon from '@mui/icons-material/BloodtypeOutlined'

export const BloodGroupTable = ({ bloodGroups = [], loading }) => {
  const sortedGroups = [...bloodGroups].sort(
    (a, b) => (b.donors ?? 0) - (a.donors ?? 0)
  )

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
      }}
    >
      <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <BloodtypeOutlinedIcon sx={{ fontSize: 20 }} />
        <Typography variant='h6' fontWeight={700}>
          Most Common Donor Groups
        </Typography>
      </Stack>

      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Donor Group</TableCell>
              <TableCell align='right'>Donors</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: 8 }).map((_, index) => (
                  <TableRow key={index}>
                    <TableCell colSpan={2}>
                      <Skeleton variant='text' />
                    </TableCell>
                  </TableRow>
                ))
              : sortedGroups.map(group => (
                  <TableRow key={group.blood_group}>
                    <TableCell>{group.blood_group}</TableCell>
                    <TableCell align='right'>
                      {group.donors} ({group.percentage}%)
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && (
        <Typography
          variant='caption'
          color='text.secondary'
          sx={{ display: 'block', mt: 1.5, textAlign: 'center' }}
        >
          Percentages may not equal 100% due to rounding.
        </Typography>
      )}
    </Paper>
  )
}

BloodGroupTable.propTypes = {
  bloodGroups: PropTypes.array,
  loading: PropTypes.bool,
}
